import React from "react";

const RightTime = ({ time }) => {
  return (
    <div className="text-xs text-right text-slate-500 font-medium">{time}</div>
  );
};

export default RightTime;
